/* src/app/common/components/food-type-indicator/food-type-indicator.component.scss */
:host {
  border: 1px solid #000;
  background-color: rgba(255, 255, 255, 0.5);
  display: inline-block;
  padding: 0.2rem;
}
:host(.veg) {
  border-color: #008000;
}
:host(.veg) .circle {
  background-color: #008000;
}
:host(.non-veg) {
  border-color: #ad4728;
}
:host(.non-veg) .circle {
  background-color: #ad4728;
}
.circle {
  height: 0.6rem;
  width: 0.6rem;
  border-radius: 50%;
  background-color: #000;
}
/*# sourceMappingURL=food-type-indicator.component.css.map */
